import { 
    CREATEREFERALDEPARTMENTCOMMISSION,
    CREATEREFERALPAYMENT,
    CREATEREFERALPERSON, 
    DELETEREFERALDEPARTMENTCOMMISSION, 
    DELETEREFERALPAYMENT, 
    DELETEREFERALPERSON, 
    GETREFERALDEPARTMENTCOMMISSION, 
    GETREFERALPAYMENT, 
    GETREFERALPERSON, 
    UPDATEREFERALDEPARTMENTCOMMISSION, 
    UPDATEREFERALPAYMENT, 
    UPDATEREFERALPERSON,

    CREATEREFERALPERSONDOCUMENT,
    GETREFERALPERSONDOCUMENT,
    UPDATEREFERALPERSONDOCUMENT,
    DELETEREFERALPERSONDOCUMENT,

    APPROVAL_WORKFLOW_CREATE,
    APPROVAL_WORKFLOW_GET_ALL,
    PENDING_APPROVAL_WORKFLOW_GET_ALL,
    UPDATEREFERRALAPPROVALWORKFLOW,
    DELETEREFERRALAPPROVALWORKFLOW,
    



 } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEREFERALPERSON:
            return {
                ...state,
                referalpersonSaveStatus: action.payload.success,
            }
        case GETREFERALPERSON:
                return {
                        ...state,
                        referalpersonList: action.payload.data,
                        }
        case UPDATEREFERALPERSON:
                return {
                        ...state,
                        referalpersonUpdateStatus: action.payload.success,
                        }   

        case DELETEREFERALPERSON:
                 return {
                     ...state,
                     referalpersonDeleteStatus: action.payload.success,
                        } 

        case CREATEREFERALPERSONDOCUMENT:
            return {
                ...state,
                referalpersonDocumentSaveStatus: action.payload.success,
            }


        case GETREFERALPERSONDOCUMENT:
            return {
                ...state,
                referalpersonDocumentList: action.payload.data || action.payload,
            }
        case UPDATEREFERALPERSONDOCUMENT:
            return {
                ...state,
                referalpersonDocumentUpdateStatus: action.payload.success,
            }
        case DELETEREFERALPERSONDOCUMENT:
            return {
                ...state,
                referalpersonDocumentDeleteStatus: action.payload.success,
            }

        case CREATEREFERALDEPARTMENTCOMMISSION:
            return {
                ...state,
                referaldepartmentcommissionSaveStatus: action.payload.success,
            }
        case GETREFERALDEPARTMENTCOMMISSION:
                return {
                        ...state,
                        referaldepartmentcommissionList: action.payload.data,
                        }
        case UPDATEREFERALDEPARTMENTCOMMISSION:
                return {
                        ...state,
                        referaldepartmentcommissionUpdateStatus: action.payload.success,
                        }   

        case DELETEREFERALDEPARTMENTCOMMISSION:
                 return {
                     ...state,
                     referaldepartmentcommissionDeleteStatus: action.payload.success,
                        } 
        case CREATEREFERALPAYMENT:
            return {
                ...state,
                referalpaymentSaveStatus: action.payload.success,
            }
        case GETREFERALPAYMENT:
                return {
                        ...state,
                        referalpaymentList: action.payload.data,
                        }
        case UPDATEREFERALPAYMENT:
                return {
                        ...state,
                        referalpaymentUpdateStatus: action.payload.success,
                        }   

        case DELETEREFERALPAYMENT:
                 return {
                     ...state,
                     referalpaymentDeleteStatus: action.payload.success,
                        } 

        case APPROVAL_WORKFLOW_CREATE:
                return {
                    ...state,
                    approvalWorkflowList: [...state.approvalWorkflowList, action.payload],
                };
        case APPROVAL_WORKFLOW_GET_ALL:
                return {
                    ...state,
                    approvalWorkflowList: action.payload,
                };

        case "PENDING_APPROVAL_WORKFLOW_GET_ALL":
                return {
                    ...state,
                    pendingApprovalWorkflowList: action.payload,
                };
        case UPDATEREFERRALAPPROVALWORKFLOW: {
                const updated = action.payload?.data || action.payload;
                return {
                    ...state,
                    approvalWorkflowList: state.approvalWorkflowList.map((row) =>
                    row.id === updated.id ? { ...row, ...updated } : row
                    ),
                };
                }

        case DELETEREFERRALAPPROVALWORKFLOW: {
      // Payload me deleted record ka id hona chahiye — response shape confirm kar lena
                const deletedId = action.payload?.data?.id || action.payload?.id;
                return {
                    ...state,
                    approvalWorkflowList: state.approvalWorkflowList.filter(
                    (row) => row.id !== deletedId
                    ),
                };
                }

        

                        default:
                            return state
                             }

                            }
    
                         
       